export enum LogType {
    Login = 1,
    Logout = 2,
    Open = 3,
    Download = 4,
    Nav = 5,
    DownloadPDF = 6,
    NavCarousel = 7,
    NavNovelty = 8,
    Click = 9,
    NavMacroBanner = 10
}
